import { render, staticRenderFns } from "./Subindicators.vue?vue&type=template&id=a12be97c&scoped=true&"
import script from "./Subindicators.vue?vue&type=script&lang=js&"
export * from "./Subindicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12be97c",
  null
  
)

export default component.exports